import { convertArrayToCSV } from 'convert-array-to-csv';
import { forEachRight } from 'lodash';
import { getCommonReportFields, getExistingFilterFlags } from './services/reportFieldsService';

const prepareData = async (data, isBaseline, requestedReports) => {
  let preparedData = [];

  const { hasOhtFilter, hasDeviceClassesFilter } = getExistingFilterFlags(
    isBaseline,
    requestedReports
  );

  preparedData = data.map((pa, idx) => {
    const dataPoint = getCommonReportFields(
      pa,
      requestedReports,
      idx,
      isBaseline,
      hasOhtFilter,
      hasDeviceClassesFilter
    );

    const total = pa.AggregatePercentage.map(x => x.Results).reduce((a, b) => a + b, 0);
    if (total < 3) {
      forEachRight(pa.AggregatePercentage, agg => {
        dataPoint[`${agg.Name}`] = `N/A`;
      });
      dataPoint[`Total`] = `N/A`;
    } else {
      forEachRight(pa.AggregatePercentage, agg => {
        dataPoint[`${agg.Name}`] = `${agg.Results}`;
      });
      dataPoint[`Total`] = `${total}`;
    }

    return dataPoint;
  });

  return preparedData.flat();
};

export const getAggregatePercentageCSV = async (data, requestedReports) => {
  const isBaseline = !!data.baselineReport;
  data = isBaseline ? data.baselineReport.PracticeAreas : data.appraisalView.PracticeAreas;

  const preppedData = await prepareData(data, isBaseline, requestedReports);
  return convertArrayToCSV(preppedData);
};
